const pageNameKey = "gatewaysListHeader";

export const gatewaysListHeaderEn = {
  [pageNameKey]: {
    statusAndGateway: "Status - Gateway",
    vendorId: "Vendor ID",
    gatewayUuid: "Gateway UUID",
    expandAll: "Expand all",
    closeAll: "Close all",
  },
};

export const gatewaysListHeaderPtBr = {
  [pageNameKey]: {
    statusAndGateway: "Status - Gateway",
    vendorId: "ID do fornecedor",
    gatewayUuid: "UUID do gateway",
    expandAll: "Expandir tudo",
    closeAll: "Fechar tudo",
  },
};

export const gatewaysListHeaderDe = {
  [pageNameKey]: {
    statusAndGateway: "Status - Gateway",
    vendorId: "Vendor ID",
    gatewayUuid: "Gateway UUID",
    expandAll: "Alle öffnen",
    closeAll: "Alle schließen",
  },
};

export const gatewaysListHeaderZhHans = {
  [pageNameKey]: {
    statusAndGateway: "状态 - 网关",
    vendorId: "供应商ID",
    gatewayUuid: "网关UUID",
    expandAll: "展开全部",
    closeAll: "关闭全部",
  },
};

export const gatewaysListHeaderIt = {
  [pageNameKey]: {
    statusAndGateway: "Stato - Gateway",
    vendorId: "ID produttore",
    gatewayUuid: "Gateway UUID",
    expandAll: "Espandi tutto",
    closeAll: "Riduci tutto",
  },
};

export const gatewaysListHeaderEs = {
  [pageNameKey]: {
    statusAndGateway: "Estado - Gateway",
    vendorId: "Proveedor ID",
    gatewayUuid: "Gateway UUID",
    expandAll: "Expandir todo",
    closeAll: "Cerrar todo",
  },
};

export const gatewaysListHeaderNl = {
  [pageNameKey]: {
    closeAll: "Alles sluiten",
    expandAll: "Alles openen",
    gatewayUuid: "Gateway-UUID",
    statusAndGateway: "Status - Gateway",
    vendorId: "Leverancier-ID",
  },
};

export const gatewaysListHeaderTr = {
  [pageNameKey]: {
    closeAll: "Tümünü kapat",
    expandAll: "Tümünü genişlet",
    gatewayUuid: "Ağ Geçidi UUID'si",
    statusAndGateway: "Durum - Ağ Geçidi",
    vendorId: "Satıcı Kimliği",
  },
};
